import { LinearProgress } from '@material-ui/core';
import iconQA from '../images/QA-icon.png';
import iconJS from '../images/JS-icon.png';
import iconFREE from '../images/free-icon.png';
import iconAUTO from '../images/AUTO-icon.png';
import iconREACT from '../images/REACT-icon.png';
import React from 'react';

const CourseCard = ({ group, max, current, onEdit, onRemove, style, cardKey, onClick }) => {

    const getTitle = (group) => {
        switch (group?.split('-')[0]) {
            case 'FREE':
                return 'Free'
            case 'JS':
                return 'JavaScript'
            case 'QA':
                return 'Quality Assurance'
            case 'REACT':
                return 'Front-end'
            case 'AUTO':
                return 'Automation'
            default:
                return ''
        }
    }

    const getIcon = (group) => {
        switch (group.split('-')[0]) {
            case 'JS':
                return iconJS
            case 'FREE':
                return iconFREE
            case 'QA':
                return iconQA
            case 'REACT':
                return iconREACT
            case 'AUTO':
                return iconAUTO
            default:
                return ''
        }
    }

    return <div style={{ ...style }} className={`course-card ${onClick ? 'clickable' : ''}`} key={cardKey} onClick={onClick}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>
                <div style={{ maxWidth: 'lg' }}>{getTitle(group)}</div>
                <div>({group.split('-').join(') - ')}</div>
            </div>
            <div>
                <img src={getIcon(group)} alt="course" title="Course"
                    style={{ maxHeight: group.includes('AUTO') || group.includes('FREE') ? '40px' : '60px' }} />
            </div>
        </div>
        <div>
            <LinearProgress color={group.includes('JS') || group.includes('REACT') ? 'primary' : 'secondary'}
                value={100}
                variant="determinate" />
        </div>
    </div>
}

export default CourseCard